import createReauthHandler from './createReauthHandler';
import createUnauthorizedApiResponseHandler from './createUnauthorizedApiResponseHandler';
export default function wrapper(reauthService, apiContext) {
    const performReauth = createReauthHandler(reauthService, apiContext);
    return function applyReauth(serviceFunc) {
        return function serviceFuncWithReauth(...serviceFuncArgs) {
            let apiAuth = null;
            const _serviceFuncWithReauth = createUnauthorizedApiResponseHandler(serviceFunc, ...serviceFuncArgs);
            const authInjectionHandler = (apiResponse) => {
                apiResponse.auth = apiAuth;
                return apiResponse;
            };
            const authErrorInjectionHandler = (apiResponse) => Promise.reject(authInjectionHandler(apiResponse));
            const onNeedsReauth = () => performReauth(_serviceFuncWithReauth)
                .then((handlerResponse) => {
                if (handlerResponse.auth) {
                    apiAuth = handlerResponse.auth;
                    return _serviceFuncWithReauth();
                }
                return handlerResponse;
            })
                .then(authInjectionHandler, authErrorInjectionHandler);
            return _serviceFuncWithReauth(onNeedsReauth);
        };
    };
}
